<template>
  <div>
    <div class="search-table">
      <el-date-picker
          style="width: 115px"
          :clearable="false"
          v-model="filters.monthAndYear"
          type="month"
          @change="handleFilterChange"
          placeholder="Chọn tháng"
          value-format="M-yyyy"
          format="MM-yyyy"
      />

      <el-input
          @clear="handleClearKidName"
          clearable
          style="width: 300px"
          placeholder="Nhập tên"
          v-model="filters.kidName"
          @keyup.enter.native="handleSearchResultByName"
      >
        <template #append>
          <el-button icon="el-icon-search" @click="handleSearchResultByName"/>
        </template>
      </el-input>

    </div>

    <div class="table-content row-data" style="margin-top: 12px">
      <el-tabs type="card" v-model="activeTabName" @tab-click="handleTabChange">
        <el-tab-pane label="HĐ lưu nháp" name="invoice-list">
          <InvoiceTabListOther
              :rows="pagedRows"
              :loading="loadingData"
              :empty-text="textTable"
              @action="handleTabAction"
              @refresh="fetchInvoiceManagement"
              @open-preview="handleOpenPreview"
              @edit-draft="handleEditDraft"
              @selection-change="handleTableSelectionChange"
          />
        </el-tab-pane>

        <!--        <el-tab-pane label="Hóa đơn nháp" name="draft-list">-->
        <!--          <InvoiceTabDraft-->
        <!--              :rows="pagedRows"-->
        <!--              :loading="loadingData"-->
        <!--              :empty-text="textTable"-->
        <!--              @action="handleTabAction"-->
        <!--              @refresh="fetchInvoiceManagement"-->
        <!--              @open-preview="handleOpenPreview"-->
        <!--              @selection-change="handleTableSelectionChange"-->
        <!--          />-->
        <!--        </el-tab-pane>-->

        <el-tab-pane label="Đã phát hành" name="issued-list">
          <InvoiceTabIssuedOther
              :rows="pagedRows"
              :loading="loadingData"
              :empty-text="textTable"
              @action="handleTabAction"
              @refresh="fetchInvoiceManagement"
              @selection-change="handleTableSelectionChange"
          />
        </el-tab-pane>
      </el-tabs>
    </div>

    <!-- Preview dialog for draft PDF -->
    <DialogBase
        :visible.sync="previewDialogVisible"
        title="Xem trước hóa đơn nháp"
        width="90%"
        top="1vh"
        :use-panel="false"
        :show-cancel="false"
        confirm-text="Đóng"
        confirm-type="danger"
        :confirm-icon="''"
        dialog-class="preview-dialog-no-limit"
        append-to-body
        :close-on-click-modal="true"
        @confirm="handlePreviewDialogClose"
        @before-close="handlePreviewDialogBeforeClose"
    >
      <div v-if="previewPdfUrl" class="preview-pdf-wrapper">
        <object :data="previewPdfUrl" type="application/pdf" class="preview-pdf-iframe"
                :style="{width: '100%', height: 'calc(100vh - 220px)'}">
          <iframe :src="previewPdfUrl" style="width:100%;height:100%;border:none;"/>
        </object>
      </div>
      <div v-else>
        <pre class="preview-json">Không có file</pre>
      </div>
    </DialogBase>
    <el-row style="margin-top: 15px;">
      <el-col :span="15" style="display: inline-flex; justify-content: right">
        <el-pagination
            style="margin-right: 5.2rem; margin-left: auto"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="filters.page"
            :page-sizes="listSizeLimit"
            :page-size="filters.limit"
            layout="prev, pager, sizes, next"
            :total="totalRows"
        />
      </el-col>
      <el-col :span="9" style="display: inline-flex; justify-content: right">
        <div class="batch-action-menu">
          <el-dropdown
              trigger="click"
              @command="handleBatchDropdownCommand"
          >
            <el-button
                type="success"
                size="medium"
                :loading="batchActionLoading.issue || batchActionLoading.delete || batchActionLoading.sendTaxAuthority || batchActionLoading.updatePaymentStatus || batchActionLoading.updateDraftStatus"
                :disabled="loadingData"
            >
              Tác vụ
              <i class="el-icon-arrow-down el-icon--right"></i>
            </el-button>
            <template #dropdown>
              <el-dropdown-menu class="batch-action-dropdown-menu">
                <el-dropdown-item
                    command="create-invoice"
                    v-if="activeTabName === 'invoice-list'"
                    :disabled="batchActionLoading.issue || batchActionLoading.delete || batchActionLoading.sendTaxAuthority || loadingData"
                >
                  Tạo mới HĐ
                </el-dropdown-item>
                <el-dropdown-item
                    v-if="activeTabName === 'invoice-list' && checkPermission(['electronic-invoice-create-issued']) && getSinvoiceConfigField('usbDigitalSignature', false) === false"
                    command="issue"
                    :disabled="batchActionLoading.issue || batchActionLoading.delete || batchActionLoading.sendTaxAuthority || loadingData"
                >
                  Phát hành hóa đơn
                </el-dropdown-item>
                <el-dropdown-item
                    v-if="activeTabName === 'invoice-list'"
                    command="release-invoice-draft"
                    :disabled="batchActionLoading.issue || batchActionLoading.delete || batchActionLoading.sendTaxAuthority || batchActionLoading.updatePaymentStatus || loadingData"
                >
                  Phát hành HĐ nháp
                </el-dropdown-item>
                <el-dropdown-item
                    v-if="activeTabName === 'invoice-list'"
                    command="update-invoice-draft"
                    :disabled="batchActionLoading.issue || batchActionLoading.delete || batchActionLoading.sendTaxAuthority || batchActionLoading.updatePaymentStatus || batchActionLoading.updateDraftStatus || loadingData"
                >
                  Cập nhật trạng thái HĐ nháp
                </el-dropdown-item>
                <el-dropdown-item
                    v-if="activeTabName === 'issued-list'"
                    command="update-issue"
                    :disabled="batchActionLoading.issue || batchActionLoading.delete || batchActionLoading.sendTaxAuthority || batchActionLoading.updatePaymentStatus || loadingData"
                >
                  Đồng bộ trạng thái HĐ
                </el-dropdown-item>
                <el-dropdown-item
                    v-if="activeTabName === 'issued-list'"
                    command="update-payment-status"
                    :disabled="batchActionLoading.issue || batchActionLoading.delete || batchActionLoading.sendTaxAuthority || batchActionLoading.updatePaymentStatus || loadingData"
                >
                  Cập nhật trạng thái thanh toán
                </el-dropdown-item>
                <el-dropdown-item
                    v-if="activeTabName === 'issued-list' && checkPermission(['send-tax-authority']) &&  getUsbDigitalSignatureConfig() === false"
                    command="sendTaxAuthority"
                    :disabled="batchActionLoading.delete || batchActionLoading.issue || batchActionLoading.sendTaxAuthority || batchActionLoading.updatePaymentStatus || loadingData"
                >
                  Gửi cơ quan thuế
                </el-dropdown-item>
                <el-dropdown-item
                    v-if="activeTabName === 'invoice-list'"
                    command="delete"
                    :disabled="batchActionLoading.delete || batchActionLoading.issue || batchActionLoading.sendTaxAuthority || batchActionLoading.updatePaymentStatus || loadingData"
                    class="batch-action-delete-item"
                >
                  Xóa hóa đơn
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </el-col>
    </el-row>

    <DialogBase
        :visible.sync="confirmIssueDialogVisible"
        title="Xác nhận"
        width="500px"
        :use-panel="false"
        :close-on-click-modal="true"
        append-to-body
        cancel-text="Hủy"
        confirm-text="Đồng ý"
        confirm-type="primary"
        :cancel-icon="''"
        :confirm-icon="''"
        @confirm="handleConfirmIssueSelectedInvoices"
    >
      <div>Bạn có chắc chắn muốn phát hành {{ pendingIssueTransactionUuids.length }} hóa đơn đã chọn không?</div>
    </DialogBase>

    <DialogBase
        :visible.sync="draftStatusDialogVisible"
        title="Cập nhật trạng thái HĐ nháp"
        size="sm"
        width="520px"
        panel-title="Chọn thời gian đồng bộ"
        panel-subtitle="Bạn có thể đồng bộ theo tháng hoặc chọn tất cả thời gian"
        panel-icon="el-icon-date"
        panel-icon-tone="warning"
        cancel-text="Hủy"
        confirm-text="Đồng ý"
        :confirm-loading="batchActionLoading.updateDraftStatus"
        :confirm-disabled="isDraftStatusConfirmDisabled"
        append-to-body
        @confirm="handleConfirmUpdateInvoiceDraftStatus"
    >
      <div class="draft-status-time-form">
        <el-checkbox v-model="draftStatusAllTime">Tất cả thời gian</el-checkbox>
        <el-date-picker
            v-model="draftStatusMonth"
            type="month"
            value-format="M-yyyy"
            format="MM-yyyy"
            placeholder="Chọn tháng"
            :clearable="false"
            :disabled="draftStatusAllTime"
            class="draft-status-time-picker"
        />
      </div>
    </DialogBase>

    <DialogBase
        :visible.sync="paymentStatusDialogVisible"
        title="Cập nhật trạng thái thanh toán"
        width="460px"
        :use-panel="false"
        :close-on-click-modal="true"
        append-to-body
        cancel-text="Hủy"
        confirm-text="Đồng ý"
        confirm-type="primary"
        :cancel-icon="''"
        :confirm-icon="''"
        :confirm-loading="batchActionLoading.updatePaymentStatus"
        :confirm-disabled="paymentStatusSelection === null"
        @confirm="handleSelectPaymentStatus"
    >
      <el-radio-group v-model="paymentStatusSelection" style="margin-top: 12px; display: flex; gap: 18px;">
        <el-radio :label="true">Đã thanh toán</el-radio>
        <el-radio :label="false">Chưa thanh toán</el-radio>
      </el-radio-group>
    </DialogBase>

    <InvoiceCreateDialog
        :isCreateInvoice="isCreateInvoice"
        :invoicePurpose="invoicePurpose"
        :isOpenInvoiceCreateDialog.sync="invoiceCreateDialogVisible"
        :initialItems="editingInvoiceItems"
        :initialDraft="editingInvoiceDraft"
        :editingTransactionUuid="editingTransactionUuid"
        :kidCode="editingKidCode"
        :orderKidCode="editingOrderKidCode"
        @invoice-action-success="handleInvoiceActionSuccess"
        @dialog-close="handleCloseInvoiceCreateDialog"
        @back="handleCloseInvoiceCreateDialog"
        @clear-invoice-form="handleInvoiceFormCleared"
    />
    <InvoiceSendAppDialog
        :isOpenInvoiceSendAppDialog="isOpenInvoiceSendAppDialog"
        :transactionUuid="transactionUuid"
        @close="closeInvoiceSendAppDialog"
    />
  </div>
</template>

<script>
import moment from "moment";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import ElectronicInvoicesService from "@/services/ElectronicInvoicesService";
import InvoiceTabListOther from "./invoice-management-other/tabs/InvoiceTabListOther.vue";
import InvoiceTabIssuedOther from "./invoice-management-other/tabs/InvoiceTabIssuedOther.vue";
import InvoiceCreateDialog from "@/components/sinvoice_viettel/dialog/InvoiceCreateDialog.vue";
import DialogBase from "@/components/DialogBase.vue";
import sinvoiceConfigMixin from "@/global/mixin/sinvoiceConfig.mixin";
import checkPermission from "@/utils/permission";
import InvoiceSendAppDialog from "@/components/sinvoice_viettel/dialog/InvoiceSendAppDialog.vue";

const PREVIEW_PRINT_MODE_CLASS = "sinvoice-preview-print-mode";

export default {
  name: "InvoiceManagementOther",
  mixins: [sinvoiceConfigMixin],
  components: {
    DialogBase,
    InvoiceSendAppDialog,
    InvoiceTabListOther,
    InvoiceTabIssuedOther,
    InvoiceCreateDialog,
  },
  data() {
    return {
      isCreateInvoice: false,
      activeTabName: "invoice-list",
      loadingData: false,
      invoicePurpose: "OTHER",
      filters: {
        invoicePurpose: "OTHER",
        invoiceStatus: "ONEKIDS_DRAFT",
        monthAndYear: moment().format("M-yyyy"),
        kidName: "",
        month: "",
        year: "",
        page: 1,
        limit: 25,
      },
      listSizeLimit: [25, 50, 100, 200, 300, 500],
      textTable: this.$tableEmpty || "Không có dữ liệu",
      rows: [],
      totalRows: 0,
      previewDialogVisible: false,
      previewPdfUrl: null,
      previewRequest: null,
      previewPayloadText: '',
      actionLoading: {
        save: false
      },
      invoiceCreateDialogVisible: false,
      editingInvoiceDraft: null,
      editingTransactionUuid: "",
      editingKidCode: "",
      editingOrderKidCode: "",
      editingInvoiceItems: [],
      selectedRows: [],
      batchActionLoading: {
        issue: false,
        delete: false,
        sendTaxAuthority: false,
        updatePaymentStatus: false,
        updateDraftStatus: false,
      },
      confirmIssueDialogVisible: false,
      pendingIssueTransactionUuids: [],
      paymentStatusDialogVisible: false,
      paymentStatusSelection: null,
      draftStatusDialogVisible: false,
      draftStatusAllTime: false,
      draftStatusMonth: moment().format("M-yyyy"),
      isOpenInvoiceSendAppDialog: false,
      transactionUuid: [],
    };
  },
  computed: {
    pagedRows() {
      return this.rows;
    },
    isDraftStatusConfirmDisabled() {
      return !this.draftStatusAllTime && !String(this.draftStatusMonth || "").trim();
    },
  },
  async created() {
    this.syncMonthYear();
    await this.fetchInvoiceManagement();
  },
  beforeDestroy() {
    this.setPreviewPrintMode(false);
  },
  methods: {
    checkPermission,
    setPreviewPrintMode(enabled) {
      const htmlRoot = document && document.documentElement ? document.documentElement : null;
      if (!htmlRoot) {
        return;
      }
      htmlRoot.classList.toggle(PREVIEW_PRINT_MODE_CLASS, !!enabled);
    },
    async handleOpenPreview(payload) {
      try {
        // payload: { arraybuffer, request }
        const arraybuffer = payload && payload.arraybuffer ? payload.arraybuffer : payload;
        const request = payload && payload.request ? payload.request : null;
        // create blob url
        const blob = new Blob([arraybuffer], {type: 'application/pdf'});
        const url = window.URL.createObjectURL(blob);
        // revoke previous if any
        if (this.previewPdfUrl) {
          window.URL.revokeObjectURL(this.previewPdfUrl);
        }
        this.previewPdfUrl = url;
        this.previewRequest = request;
        try {
          this.previewPayloadText = JSON.stringify(request, null, 2);
        } catch (e) {
          this.previewPayloadText = String(request || '');
        }
        this.previewDialogVisible = true;
        this.setPreviewPrintMode(true);
      } catch (err) {
        console.error('open preview failed', err);
        NotifyMessage.leftCornerNotificationError('Không thể mở xem trước');
      }
    },

    handlePreviewDialogBeforeClose(done) {
      this.handlePreviewDialogClose();
      done();
    },
    handlePreviewDialogClose() {
      if (this.previewPdfUrl) {
        window.URL.revokeObjectURL(this.previewPdfUrl);
        this.previewPdfUrl = null;
      }
      this.previewRequest = null;
      this.previewDialogVisible = false;
      this.setPreviewPrintMode(false);
    },

    cloneData(value) {
      if (value === null || value === undefined) return value;
      try {
        return JSON.parse(JSON.stringify(value));
      } catch (e) {
        return value;
      }
    },
    handleEditDraft(row) {
      const draft = row && row.draft ? this.cloneData(row.draft) : null;
      if (!draft) {
        NotifyMessage.leftCornerNotificationError("Không có dữ liệu nháp để chỉnh sửa");
        return;
      }
      this.editingInvoiceDraft = draft;
      this.editingTransactionUuid = row && row.transactionUuid
          ? String(row.transactionUuid)
          : (draft.generalInvoiceInfo && draft.generalInvoiceInfo.transactionUuid ? String(draft.generalInvoiceInfo.transactionUuid) : "");
      this.editingKidCode = row && row.kidCode ? String(row.kidCode) : "";
      this.editingOrderKidCode = row && row.orderKidCode ? String(row.orderKidCode) : "";
      this.editingInvoiceItems = draft && Array.isArray(draft.itemInfo) ? this.cloneData(draft.itemInfo) : [];
      this.invoiceCreateDialogVisible = true;
      // Auto scroll to dialog when opening edit mode
      this.$nextTick(() => {
        const dialogElems = document.querySelectorAll('.el-dialog');
        if (dialogElems.length > 0) {
          const lastDialog = dialogElems[dialogElems.length - 1];
          lastDialog.scrollIntoView({behavior: 'smooth', block: 'start'});
        }
      });
    },
    handleCloseInvoiceCreateDialog() {
      this.invoiceCreateDialogVisible = false;
      this.editingInvoiceDraft = null;
      this.editingTransactionUuid = "";
      this.editingKidCode = "";
      this.editingOrderKidCode = "";
      this.editingInvoiceItems = [];
    },
    handleInvoiceFormCleared() {
      // giữ state edit ở parent cho tới khi dialog đóng hẳn
    },
    async handleInvoiceActionSuccess(payload = {}) {
      if (payload.action === 'preview') {
        return;
      }
      this.handleCloseInvoiceCreateDialog();
      await this.fetchInvoiceManagement();
    },
    handleTableSelectionChange(rows = []) {
      this.selectedRows = Array.isArray(rows) ? rows : [];
    },
    handleBatchDropdownCommand(command) {
      if (command === 'create-invoice') {
        this.handleCreateNewInvoice();
        return;
      }
      if (command === 'issue') {
        this.handleIssueSelectedInvoices();
        return;
      }
      if (command === 'delete') {
        this.handleDeleteSelectedInvoices();
        return;
      }
      if (command === 'sendTaxAuthority') {
        this.handleSendTaxAuthoritySelectedInvoices();
      }
      if (command === "update-issue") {
        this.updateIssueStatus();
        return;
      }
      if (command === "update-invoice-draft") {
        this.openUpdateDraftStatusDialog();
        return;
      }
      if (command === "sendToApp") {
        this.sendToApp();
        return;
      }
      if (command === "update-payment-status") {
        this.handleOpenPaymentStatusDialog();
      }
      if (command === "release-invoice-draft") {
        this.releaseInvoiceDraftStatus();
        return;
      }

    },

    async releaseInvoiceDraftStatus(){
      const ids = this.getSelectedTransactionUuids();
      if (ids.length === 0) {
        NotifyMessage.leftCornerNotificationError("Vui lòng chọn hóa đơn để lập hóa đơn nháp trên S-Invoice");
        return;
      }
      try {
        await this.$confirm(`Bạn có chắc chắn muốn lập hóa đơn nháp trên S-Invoice cho ${ids.length} hóa đơn đã chọn?`, "Xác nhận", {
          confirmButtonText: "Đồng ý",
          cancelButtonText: "Hủy",
          type: "warning",
        });
      } catch (e) {
        return;
      }
      try {
        const request = {transactionUuids: ids};
        const resp = await ElectronicInvoicesService.createMultiDraftInvoiceFromDraft(request);
        if (resp.data.data === true){
          NotifyMessage.leftCornerNotificationSuccess("Lập hóa đơn nháp trên S-Invoice thành công")
        } else {
          NotifyMessage.leftCornerNotificationError("Lập hóa đơn nháp trên S-Invoice thất bại")
        }
      } catch (e){
        NotifyMessage.leftCornerNotificationError("Lập hóa đơn nháp trên S-Invoice thất bại")
      } finally {
        this.clearSelectionState();
        await this.fetchInvoiceManagement();
      }
    },

    handleOpenPaymentStatusDialog() {
      if (this.activeTabName !== "issued-list") {
        NotifyMessage.leftCornerNotificationError("Chỉ có thể cập nhật trạng thái thanh toán ở tab Đã phát hành");
        return;
      }

      const ids = this.getSelectedTransactionUuids();
      if (ids.length === 0) {
        NotifyMessage.leftCornerNotificationError("Vui lòng chọn hóa đơn hợp lệ để cập nhật trạng thái thanh toán");
        return;
      }

      this.paymentStatusSelection = null;
      this.paymentStatusDialogVisible = true;
    },
    async handleSelectPaymentStatus() {
      if (this.paymentStatusSelection === null) {
        NotifyMessage.leftCornerNotificationError("Vui lòng chọn trạng thái thanh toán");
        return;
      }
      this.paymentStatusDialogVisible = false;
      const isPaid = this.paymentStatusSelection === true;
      await this.handleUpdatePaymentStatusSelectedInvoices(isPaid);
    },
    handleCreateNewInvoice() {
      this.editingInvoiceDraft = null;
      this.editingTransactionUuid = "";
      this.editingKidCode = "";
      this.editingOrderKidCode = "";
      this.editingInvoiceItems = [];
      this.invoiceCreateDialogVisible = true;
    },
    sendToApp() {
      this.transactionUuid = this.getSelectedTransactionUuids();
      if (this.transactionUuid.length === 0) {
        NotifyMessage.leftCornerNotificationError("Vui lòng chọn hóa đơn hợp lệ gủi qua app");
        return;
      }
      this.isOpenInvoiceSendAppDialog = true
    },
    closeInvoiceSendAppDialog() {
      this.isOpenInvoiceSendAppDialog = false
      this.fetchInvoiceManagement();
    },
    async updateIssueStatus() {
      ElectronicInvoicesService.syncToTaxAuthorities().then(() => {
        NotifyMessage.leftCornerNotificationSuccess("Cập nhật trạng thái hóa đơn thành công")
        this.fetchInvoiceManagement();
      }).catch(() => {
        NotifyMessage.leftCornerNotificationError("Cập nhật trạng thái hóa đơn thất bại")
      })
    },
    async handleUpdatePaymentStatusSelectedInvoices(isPaid) {
      if (this.activeTabName !== "issued-list") {
        NotifyMessage.leftCornerNotificationError("Chỉ có thể cập nhật trạng thái thanh toán ở tab Đã phát hành");
        return;
      }

      const ids = this.getSelectedTransactionUuids();
      if (ids.length === 0) {
        NotifyMessage.leftCornerNotificationError("Vui lòng chọn hóa đơn hợp lệ để cập nhật trạng thái thanh toán");
        return;
      }

      const actionLabel = isPaid ? "Đã thanh toán" : "Chưa thanh toán";
      try {
        await this.$confirm(`Bạn có chắc chắn muốn cập nhật ${ids.length} hóa đơn đã chọn sang trạng thái ${actionLabel}?`, "Xác nhận", {
          confirmButtonText: "Đồng ý",
          cancelButtonText: "Hủy",
          type: "warning",
        });
      } catch (e) {
        return;
      }

      this.batchActionLoading.updatePaymentStatus = true;
      try {
        const request = {transactionUuids: ids};
        const resp = isPaid
            ? await ElectronicInvoicesService.updateInvoicePaymentStatus(request)
            : await ElectronicInvoicesService.cancelInvoicePaymentStatus(request);

        const totalSuccess = resp && resp.data && resp.data.data && resp.data.data.totalSuccess !== undefined
            ? resp.data.data.totalSuccess
            : (this.isResponseSuccess(resp) ? ids.length : 0);
        const totalFail = resp && resp.data && resp.data.data && resp.data.data.totalFail !== undefined
            ? resp.data.data.totalFail
            : ids.length - totalSuccess;

        if (totalFail === 0 && totalSuccess > 0) {
          NotifyMessage.leftCornerNotificationSuccess(`Cập nhật trạng thái ${actionLabel.toLowerCase()} thành công ${totalSuccess} hóa đơn.`);
        } else if (totalSuccess === 0) {
          NotifyMessage.leftCornerNotificationError(`Cập nhật trạng thái ${actionLabel.toLowerCase()} thất bại`);
        } else {
          NotifyMessage.leftCornerNotificationError(`Cập nhật trạng thái ${actionLabel.toLowerCase()} thành công ${totalSuccess}, thất bại ${totalFail}`);
        }
      } catch (e) {
        NotifyMessage.leftCornerNotificationError(`Cập nhật trạng thái ${actionLabel.toLowerCase()} thất bại`);
      } finally {
        this.batchActionLoading.updatePaymentStatus = false;
        this.clearSelectionState();
        await this.fetchInvoiceManagement();
      }
    },
    resolveMonthDateRange() {
      const value = String(this.filters.monthAndYear || '').trim();
      const [monthStr = '', yearStr = ''] = value.split('-');
      const month = Number(monthStr);
      const year = Number(yearStr);

      if (!Number.isInteger(month) || !Number.isInteger(year) || month < 1 || month > 12 || year < 1000) {
        return null;
      }

      const start = moment({year, month: month - 1, date: 1});
      if (!start.isValid()) {
        return null;
      }

      return {
        startDate: start.format('YYYY-MM-DD'),
        endDate: start.clone().endOf('month').format('YYYY-MM-DD'),
      };
    },
    clearSelectionState() {
      this.selectedRows = [];
    },
    getSelectedTransactionUuids() {
      const ids = (this.selectedRows || [])
          .map((row) => (row && row.transactionUuid ? String(row.transactionUuid).trim() : ""))
          .filter(Boolean);
      return Array.from(new Set(ids));
    },
    isResponseSuccess(resp) {
      if (!resp) return false;
      return resp === true
          || resp.data === true
          || !!(resp.data && resp.data.data === true)
          || !!(resp.data && resp.data.success === true)
          || resp.success === true || resp.data.status === 200;
    },
    async handleIssueSelectedInvoices() {
      const ids = this.getSelectedTransactionUuids();
      if (ids.length === 0) {
        NotifyMessage.leftCornerNotificationError("Vui lòng chọn hóa đơn hợp lệ để phát hành");
        return;
      }

      if (this.activeTabName !== 'invoice-list') {
        return;
      }

      this.pendingIssueTransactionUuids = ids;
      this.confirmIssueDialogVisible = true;
    },
    handleConfirmIssueSelectedInvoices() {
      this.confirmIssueDialogVisible = false;
      this.handleSubmitIssueSelectedBySignMethod();
    },
    getUsbDigitalSignatureConfig() {
      return !!this.getSinvoiceConfigField('usbDigitalSignature', false);
    },
    async handleSubmitIssueSelectedBySignMethod() {
      const ids = Array.isArray(this.pendingIssueTransactionUuids) ? this.pendingIssueTransactionUuids : [];
      if (ids.length === 0) {
        NotifyMessage.leftCornerNotificationError("Không có dữ liệu hóa đơn để phát hành");
        return;
      }

      this.batchActionLoading.issue = true;

      try {
        const request = {transactionUuids: ids};
        const resp = this.getUsbDigitalSignatureConfig()
            ? await ElectronicInvoicesService.createMultiInvoiceFromDraftByUsbToken(request)
            : await ElectronicInvoicesService.createMultiInvoiceFromDraft(request);
        if (this.isResponseSuccess(resp)) {
          const totalSuccess = resp && resp.data && resp.data.data && resp.data.data.totalSuccess !== undefined
              ? resp.data.data.totalSuccess
              : ids.length;
          const totalFail = resp && resp.data && resp.data.data && resp.data.data.totalFail !== undefined
              ? resp.data.data.totalFail
              : 0;
          NotifyMessage.leftCornerNotificationSuccess(`Phát hành thành công ${totalSuccess} hóa đơn, thất bại: ${totalFail} hóa đơn.`);
          this.pendingIssueTransactionUuids = [];
        } else {
          NotifyMessage.leftCornerNotificationError("Phát hành hóa đơn thất bại");
        }
      } catch (e) {
        NotifyMessage.leftCornerNotificationError("Phát hành hóa đơn thất bại");
      } finally {
        this.batchActionLoading.issue = false;
        this.clearSelectionState();
        await this.fetchInvoiceManagement();
      }
    },
    async handleDeleteSelectedInvoices() {
      const ids = this.getSelectedTransactionUuids();
      if (ids.length === 0) {
        NotifyMessage.leftCornerNotificationError("Vui lòng chọn hóa đơn hợp lệ để xóa");
        return;
      }

      try {
        await this.$confirm(`Bạn có chắc chắn muốn xóa ${ids.length} hóa đơn đã chọn?`, "Xác nhận", {
          confirmButtonText: "Đồng ý",
          cancelButtonText: "Hủy",
          type: "warning",
        });
      } catch (e) {
        return;
      }

      this.batchActionLoading.delete = true;

      try {
        const request = {transactionUuids: ids};
        const resp = await ElectronicInvoicesService.deleteMultiInvoice(request);

        const totalSuccess = resp && resp.data && resp.data.data && resp.data.data.totalSuccess !== undefined
            ? resp.data.data.totalSuccess
            : (this.isResponseSuccess(resp) ? ids.length : 0);
        const totalFail = resp && resp.data && resp.data.data && resp.data.data.totalFail !== undefined
            ? resp.data.data.totalFail
            : ids.length - totalSuccess;

        if (totalFail === 0 && totalSuccess > 0) {
          NotifyMessage.leftCornerNotificationSuccess(`Xóa thành công ${totalSuccess} hóa đơn.`);
        } else if (totalSuccess === 0) {
          NotifyMessage.leftCornerNotificationError("Xóa hóa đơn thất bại");
        } else {
          NotifyMessage.leftCornerNotificationError(`Xóa thành công ${totalSuccess}, thất bại ${totalFail}`);
        }
      } catch (e) {
        NotifyMessage.leftCornerNotificationError("Xóa hóa đơn thất bại");
      } finally {
        this.batchActionLoading.delete = false;
        this.clearSelectionState();
        await this.fetchInvoiceManagement();
      }
    },
    async handleSendTaxAuthoritySelectedInvoices() {
      if (this.activeTabName !== 'issued-list') {
        NotifyMessage.leftCornerNotificationError('Chỉ có thể gửi cơ quan thuế ở tab Đã phát hành');
        return;
      }

      const ids = this.getSelectedTransactionUuids();
      if (ids.length === 0) {
        NotifyMessage.leftCornerNotificationError('Vui lòng chọn hóa đơn hợp lệ để gửi cơ quan thuế');
        return;
      }

      const dateRange = this.resolveMonthDateRange();
      if (!dateRange) {
        NotifyMessage.leftCornerNotificationError('Tháng lọc không hợp lệ, vui lòng chọn lại');
        return;
      }

      try {
        await this.$confirm(`Bạn có chắc chắn muốn gửi ${ids.length} hóa đơn đã chọn sang cơ quan thuế?`, 'Xác nhận', {
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy',
          type: 'warning',
        });
      } catch (e) {
        return;
      }

      this.batchActionLoading.sendTaxAuthority = true;

      try {
        const request = {
          transactionUuids: ids,
          startDate: dateRange.startDate,
          endDate: dateRange.endDate,
        };
        const resp = await ElectronicInvoicesService.sendMultiInvoiceAuthorities(request);
        if (this.isResponseSuccess(resp)) {
          let success = 0;
          let fail = 0;
          if (resp && resp.data) {
            const d = resp.data.data || resp.data;
            if (d) {
              success = d.success ?? d.totalSuccess ?? 0;
              fail = d.fail ?? d.totalFail ?? 0;
            }
          }
          NotifyMessage.leftCornerNotificationSuccess(`Gửi hóa đơn sang cơ quan thuế thành công: ${success}, thất bại: ${fail}`);
        } else {
          NotifyMessage.leftCornerNotificationError('Gửi hóa đơn sang cơ quan thuế thất bại');
        }
      } catch (e) {
        NotifyMessage.leftCornerNotificationError('Gửi hóa đơn sang cơ quan thuế thất bại');
      } finally {
        this.batchActionLoading.sendTaxAuthority = false;
        this.clearSelectionState();
        await this.fetchInvoiceManagement();
      }
    },

    syncMonthYear() {
      const value = this.filters.monthAndYear || "";
      const [month = "", year = ""] = String(value).split("-");
      this.filters.month = month;
      this.filters.year = year;
    },
    resolveTabType() {
      const tabMap = {
        "invoice-list": "INVOICE_LIST",
        "draft-list": "DRAFT_LIST",
        "issued-list": "ISSUED_LIST",
      };
      return tabMap[this.activeTabName] || "INVOICE_LIST";
    },
    buildFilterPayload() {
      const kidName = String(this.filters.kidName || "").trim();
      return {
        invoiceStatus: this.filters.invoiceStatus,
        monthAndYear: this.filters.monthAndYear,
        kidName,
        month: this.filters.month,
        year: this.filters.year,
        page: this.filters.page,
        limit: this.filters.limit,
        invoicePurpose: "OTHER",
        tabType: this.resolveTabType(),
      };
    },
    mapApiRows(list = []) {
      if (!Array.isArray(list)) return [];

      const pick = (...values) => {
        for (let i = 0; i < values.length; i += 1) {
          const value = values[i];
          if (value !== null && value !== undefined && value !== "") return value;
        }
        return null;
      };

      return list.map((item) => {
        const baseRow = {
          ...item,
          transactionUuid: pick(item.transactionUuid, item.id, ""),
          invoiceNo: pick(item.invoiceNo, item.reservationCode, item.transactionUuid, ""),
          kidCode: pick(item.kidCode, ""),
          kidName: pick(item.kidName, item.fullName, ""),
          fullName: pick(item.fullName, item.kidName, ""),
          buyerName: pick(item.buyerName, ""),
          orderKidCode: pick(item.orderKidCode, ""),
          status: pick(item.status, item.statusName, ""),
          createdAt: pick(item.createdAt, item.createdDate, item.createdTime, ""),
          issuedAt: pick(item.issuedAt, item.invoiceDate, item.invoiceTime, item.lastModifiedDate, ""),
          totalAmountWithTax: Number(pick(item.totalAmountWithTax, 0)) || 0,
          paymentMethodName: pick(item.paymentMethodName, ""),
          invoiceStatus: pick(item.invoiceStatus, item.statusName, item.status, ""),
          draftStatus: pick(item.draftStatus, item.statusName, item.status, ""),
          className: pick(item.className, ""),
          totalTaxAmount: Number(pick(item.totalTaxAmount, 0)) || 0,
          totalAmountWithoutTax: Number(pick(item.totalAmountWithoutTax, 0)) || 0,
          draft: pick(item.draft, null),
        };

        return {
          ...baseRow
        };
      });
    },
    async fetchInvoiceManagement() {
      this.loadingData = true;
      try {
        this.syncMonthYear();
        const payload = this.buildFilterPayload();
        const response = await ElectronicInvoicesService.searchInvoiceManagementOther(
            payload.month,
            payload.year,
            payload.invoiceStatus,
            payload.invoicePurpose,
            payload.page,
            payload.limit,
        );
        const responseData = response.data
        const list = responseData.content || [];
        const total = responseData.totalElements || 0;

        this.rows = this.mapApiRows(list);
        this.totalRows = Number(total) || 0;
        this.clearSelectionState();

      } catch (error) {
        this.rows = [];
        this.totalRows = 0;
        this.clearSelectionState();
        NotifyMessage.leftCornerNotificationError("Không lấy được dữ liệu quản lý hóa đơn");
      } finally {
        this.loadingData = false;
      }
    },
    handleFilterChange() {
      this.syncMonthYear();
      this.filters.page = 1;
      this.clearSelectionState();
      this.fetchInvoiceManagement();
    },
    handleSearchResultByName() {
      this.filters.page = 1;
      this.clearSelectionState();
      this.fetchInvoiceManagement();
    },
    handleClearKidName() {
      this.filters.kidName = "";
      this.filters.page = 1;
      this.clearSelectionState();
      this.fetchInvoiceManagement();
    },
    handleTabChange() {
      this.filters.page = 1;
      this.clearSelectionState();
      if (this.activeTabName === "draft-list") {
        this.filters.invoiceStatus = "DRAFT";
      } else if (this.activeTabName === "issued-list") {
        this.filters.invoiceStatus = "ISSUED";
      } else {
        this.filters.invoiceStatus = "ONEKIDS_DRAFT";
      }
      this.fetchInvoiceManagement();
    },
    handleSizeChange(value) {
      this.filters.limit = value;
      this.filters.page = 1;
      this.clearSelectionState();
      this.fetchInvoiceManagement();
    },
    handleCurrentChange(value) {
      this.filters.page = value;
      this.clearSelectionState();
      this.fetchInvoiceManagement();
    },
    handleTabAction({action, row}) {
      const studentLabel = row && row.fullName ? ` - ${row.fullName}` : "";
      NotifyMessage.leftCornerNotificationSuccess(`${action}${studentLabel}`);
    },
    openUpdateDraftStatusDialog() {
      this.draftStatusAllTime = false;
      this.draftStatusMonth = this.filters.monthAndYear || moment().format("M-yyyy");
      this.draftStatusDialogVisible = true;
    },
    resolveMonthYearValue(monthYearValue) {
      const value = String(monthYearValue || "").trim();
      const [monthText = "", yearText = ""] = value.split("-");
      const month = Number(monthText);
      const year = Number(yearText);
      if (!Number.isInteger(month) || !Number.isInteger(year) || month < 1 || month > 12 || year < 1000) {
        return null;
      }
      return {month, year};
    },
    async handleConfirmUpdateInvoiceDraftStatus() {
      let params = null;
      if (this.draftStatusAllTime) {
        params = {
          month: 0,
          year: 0,
          draftStatusAllTime: true,
        };
      } else {
        const monthYear = this.resolveMonthYearValue(this.draftStatusMonth);
        if (!monthYear) {
          NotifyMessage.leftCornerNotificationError("Tháng cập nhật không hợp lệ");
          return;
        }
        params = {
          month: monthYear.month,
          year: monthYear.year,
          draftStatusAllTime: false,
        };
      }
      await this.updateInvoiceDraftStatus(params);
    },
    async updateInvoiceDraftStatus(params) {
      this.batchActionLoading.updateDraftStatus = true;
      try {
        await ElectronicInvoicesService.syncToTaxAuthoritiesOnekidsDraft(params);
        this.draftStatusDialogVisible = false;
        NotifyMessage.leftCornerNotificationSuccess("Cập nhật trạng thái hóa đơn thành công");
      } catch (e) {
        NotifyMessage.leftCornerNotificationError("Cập nhật trạng thái hóa đơn thất bại");
      } finally {
        this.batchActionLoading.updateDraftStatus = false;
        await this.fetchInvoiceManagement();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.search-table {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.batch-action-menu {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.batch-action-summary {
  color: #606266;
  font-size: 13px;
  font-weight: 500;
}

::v-deep .batch-action-dropdown-menu {
  min-width: 220px;
}

::v-deep .batch-action-dropdown-menu .el-dropdown-menu__item {
  display: flex;
  align-items: center;
  min-height: 36px;
  line-height: 1.4;
}

::v-deep .batch-action-dropdown-menu .batch-action-info-item {
  color: #606266 !important;
  font-weight: 500;
}

::v-deep .batch-action-dropdown-menu .batch-action-delete-item {
  color: #f56c6c;
}

::v-deep .batch-action-dropdown-menu .batch-action-delete-item:not(.is-disabled):hover,
::v-deep .batch-action-dropdown-menu .batch-action-delete-item:not(.is-disabled):focus {
  color: #f56c6c;
  background-color: #fef0f0;
}

::v-deep .batch-action-dropdown-menu .el-dropdown-menu__item.is-disabled {
  opacity: 1;
}

::v-deep .batch-action-dropdown-menu .el-dropdown-menu__item i {
  margin-right: 6px;
}

::v-deep .el-tabs__nav-scroll {
  float: right;
}

::v-deep .el-tabs__nav-wrap {
  margin-top: 0;
  margin-bottom: -15px;
}

::v-deep .el-tabs__nav {
  background: #a0a19ce0;
}

::v-deep .el-tabs__item {
  color: white;
}

::v-deep .el-tabs__item.is-active {
  color: white;
  background: #78a5e7;
}

::v-deep .el-tabs--card > .el-tabs__header {
  border-bottom: none;
}

::v-deep .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom: none;
}

::v-deep .el-tabs__content {
  padding: 0;
}

/* Preview dialog styles (match InvoiceCreateDialog) */
.preview-pdf-wrapper {
  width: 100%;
  min-height: calc(100vh - 220px);
  box-sizing: border-box;
  display: block;
}

.preview-pdf-iframe {
  width: 100% !important;
  height: 100% !important;
  min-height: calc(100vh - 140px) !important;
  border: none !important;
  display: block !important;
}

.preview-json {
  margin: 0;
  overflow: auto;
  padding: 16px;
  background: #f5f7fa;
  border-radius: 4px;
  white-space: pre-wrap;
  word-break: break-word;
}

/* Bỏ giới hạn chiều cao body của dialog xem trước */
::v-deep .preview-dialog-no-limit .el-dialog__body {
  max-height: none !important;
  overflow: visible !important;
  padding: 0 !important;
}

/* Force dialog body and wrapper to use full available height and make PDF fill it */
::v-deep .preview-dialog-no-limit .el-dialog__body,
::v-deep .preview-dialog-no-limit .el-dialog__body > .preview-pdf-wrapper {
  display: flex !important;
  flex-direction: column !important;
  height: calc(100vh - 180px) !important;
}

::v-deep .preview-dialog-no-limit .preview-pdf-wrapper {
  flex: 1 1 auto !important;
}

::v-deep .preview-dialog-no-limit .preview-pdf-iframe,
.preview-pdf-wrapper object,
.preview-pdf-wrapper iframe {
  width: 100% !important;
  height: 100% !important;
  min-height: 600px !important;
}

.draft-status-time-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.draft-status-time-picker {
  width: 100%;
}
</style>

<style lang="scss">
@import "@/assets/style/print-mode.scss";

@include print-mode-root("sinvoice-preview-print-mode", (".preview-dialog-no-limit", ".preview-pdf-wrapper", ".preview-pdf-iframe"));
</style>

